import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SdvorProductComparisonButtonComponent } from './product-comparison-button';
import { SdvorProductWishlistButtonComponent } from './product-wishlist-button';
@Component({
  selector: 'sd-product-item-upper-buttons',
  templateUrl: './product-item-upper-buttons.component.html',
  styleUrl: './product-item-upper-buttons.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SdvorProductWishlistButtonComponent, SdvorProductComparisonButtonComponent],
})
export class SdvorProductItemUpperButtonsComponent {
  productCode = input.required<string>();
  hideWishlist = input<boolean>(false);
}
